module.exports = __webpack_public_path__ + "img/LMS-Courses-0.a13a9e0c.svg";